import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../Core/hooks';
//import { getRoadmap, setMembers, deleteMember } from '../Store/Roadmap';
import { ContextMenu } from '../Models/ContextMenu';
import { SubscriptionContextMenuParam } from '../Models/Requests/SubscriptionContexMenuParam';
import { AiOutlineClose } from "react-icons/ai";
import PopupContextMenu from './PopupContext';
import { PopupContextParam } from '../Models/Requests/PopupContextParam';
import SharingContext from "../Modals/SharingContext";
import { SharingContextParam } from "../Models/Requests/SharingContextParam";
import { openSocket } from '../Helpers/openSocket';
import { getSettings } from '../Store/Settings';
import { getStripe, createSubscription, deleteMostRecentPayment, changeSubscription } from '../Store/Stripe';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { getUser } from '../Store/Auth';
import { useIsMobile } from '../Core/hooks';

interface Props {
    params: SubscriptionContextMenuParam | undefined;    
}

function SubscriptionContextMenu(props: Props) {

    const dispatch = useAppDispatch();
    const userState = useAppSelector(getUser);
    const settingsState = useAppSelector(getSettings);
    const stripeState = useAppSelector(getStripe);
    const [popupParams, setPopupParams] = useState<PopupContextParam>();
    const [subscriptionContextMenu, setSubscriptionContextMenu] = useState<ContextMenu>();
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const isMobile = useIsMobile();
    //const [sharingContextParams, setSharingContextParams] = useState<SharingContextParam>();

    /*
    useEffect(() => {
        setSharingContextParams(undefined);
    },[])
*/
    useEffect(() => {
        if (props.params) {
            let contextMenu = { _id: "", x: 0, y: 0, width: 0, height: 0 };
            if ( (subscriptionContextMenu && subscriptionContextMenu._id !== props.params.id) || !subscriptionContextMenu) {
                if (props.params.event) {
                    let menuWidth = window.outerWidth * .4;
                    let menuHeight = window.outerHeight * .74;
                    let menuXStart = window.outerWidth * .3;
                    let menuYStart = 200;
                    /*
                    let menuXStart = props.params.event.clientX - 10;
                    let menuYStart = props.params.event.clientY + 20
                    
                    if (menuXStart + menuWidth > window.outerWidth) {
                        menuXStart = window.outerWidth - menuWidth - 80;
                    }*/
                    contextMenu._id = props.params.id;
                    contextMenu.x = menuXStart;
                    contextMenu.y = menuYStart;
                    contextMenu.width = menuWidth;
                    contextMenu.height = menuHeight;
                }
            }
            setSubscriptionContextMenu(contextMenu);
        }
    }, [props.params]);

    useEffect(() => {
        const confirmPayment = async () => {

            if (!stripe || !elements) return;
      
            const card = elements.getElement(CardElement);
            if (!card) return;
            
            try {
                const result = await stripe.confirmCardPayment(stripeState.clientSecret, {
                    payment_method: {
                        card: card,
                        billing_details: {
                        email: userState.email,
                        },
                    },
                });
      
                if (result.error) {
                    if (stripeState.mostRecentPayment) {
                        dispatch(deleteMostRecentPayment(stripeState.mostRecentPayment!._id));
                    }
                    setMessage(result.error.message || 'Payment failed.');
                    setTimeout(() => setMessage(""), 5000);
                } else {
                    closeMenu();
                    props.params?.closeHandler ();
                }

            } catch (err: any) {
                if (stripeState.mostRecentPayment) {
                    dispatch(deleteMostRecentPayment(stripeState.mostRecentPayment!._id));
                }
              setMessage(err.message || 'Something went wrong.');
              setTimeout(() => setMessage(""), 5000);
            }
      
            setLoading(false);
        };

        if (stripeState.clientSecret) {
            confirmPayment();
        }

    }, [stripeState.clientSecret, stripe, elements, userState.email]);

    const closeContextMenu = (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        closeMenu();
    }

    const closeMenu = () => {
        let contextMenu = { _id: "", x: 0, y: 0, width: 0, height: 0 };
        setSubscriptionContextMenu(contextMenu);
    }
    
    const handleCreateSubscription = (e: React.MouseEvent<HTMLButtonElement>) => {
        
        e.preventDefault();
        setLoading(true);
        setMessage('');
        //console.log("in handleSubmit");
        // Call backend to create the subscription
        if (props.params) {
            if (props.params.changingSubscription) {
                console.log(props.params.changingSubscription);
                dispatch(changeSubscription({ priceId: props.params.id }));
            } else {
                dispatch(createSubscription({ email: userState.email, priceId: props.params.id }));
            }
        }
    };
  
    const CARD_OPTIONS = {
        style: {
          base: {
            iconColor: '#a0aec0',
            color: '#1a202c',
            fontWeight: 500,
            fontFamily: 'Inter, Roboto, Open Sans, Segoe UI, sans-serif',
            fontSize: '16px',
            fontSmoothing: 'antialiased',
            '::placeholder': {
              color: '#a0aec0',
            },
          },
          invalid: {
            color: '#e53e3e',
            iconColor: '#e53e3e',
          },
        },
      };
    /*
    const sContextMenu: React.CSSProperties = {
        top: (subscriptionContextMenu) ? subscriptionContextMenu.y : 0,
        left: (subscriptionContextMenu) ? subscriptionContextMenu.x : 0,
        width: (subscriptionContextMenu) ? subscriptionContextMenu.width : 0,
        //height: "550px"
    }
    */
    const sContextMenu: React.CSSProperties = {
        top: subscriptionContextMenu && !isMobile ? subscriptionContextMenu.y : 0,
        left: subscriptionContextMenu && !isMobile ? subscriptionContextMenu.x : 0,
        width: isMobile 
            ? "100vw" 
            : subscriptionContextMenu 
                ? subscriptionContextMenu.width 
                : 300,
        height: isMobile ? "100vh" : "auto",
    };

    let plan = stripeState.plans.find(p => p.priceId === props.params?.id);

    return (
        <>
            {subscriptionContextMenu && subscriptionContextMenu._id !== "" && plan &&
                <div onClick={e => closeMenu()} className="windowContainer">
                    <div className="contextMenu" style={sContextMenu} onClick={e => { e.preventDefault(); e.stopPropagation(); }}>
                        <div style={{ position: "relative" }}>
                            <div className="divClose">
                                <Link to="" onClick={(e) => closeContextMenu(e)}>
                                    <AiOutlineClose color="#555" size="13" />
                                </Link>
                            </div>
                        </div>
                        <div style={{ fontSize: "20pt", fontWeight: "500", textAlign: "center", marginTop: "20px" }}>
                            {plan.name.toUpperCase()}
                        </div>
                        <div style={{ textAlign: "center", fontSize: ".9em", fontStyle: "italic", marginLeft: "10px", color: "#495866", fontWeight: "400" }}>
                            {plan.billingCycle === 1 && "$" + plan.price + " per user, per month, billed monthly" }
                        </div>
                        {/*
                        <div style={{ textAlign: "center", marginLeft: "10px", marginTop: "5px", fontSize: "11pt", color: "#495866", fontWeight: "400" }}>
                            {plan.description}
                        </div>
                        */}
                        <div style={{ margin: "20px 10px 20px 10px" }}>
                            <div style={{ border: "1px solid #efefef", borderRadius: "8px", padding: "10px" }}>
                                <CardElement options={CARD_OPTIONS} />
                            </div>
                            {message && 
                                <div className="error" style={{ fontSize: "11pt", marginTop: "10px", 
                                    display: "inline-block", position: "relative", padding: "5px 20px" }}>
                                    {message}
                                </div>
                            }
                            <button className="btn-orange-2" style={{ marginTop: "10px", border: "0px" }}
                                disabled={!stripe || loading} onClick={(e) => handleCreateSubscription(e)}>
                                {loading ? 'Processing...' : 'Subscribe'}
                            </button>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default SubscriptionContextMenu;